"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const map_data_service_1 = require("./map-data.service");
const map_event_objects_1 = require("./map-event.objects");
const veflux_1 = require("vasat/dist/src/veflux");
/**
 * The Service to handle all streamEvents to do with the map.
 * As well as take commands from componets that wish to maniplate the map's camrea and cusor
 */
class MapEventService {
    constructor(mapData) {
        this.mapData = mapData;
        this.loading = false;
        this._clickStack = [];
        this._map = new veflux_1.Store(map_event_objects_1.MapEvent);
        this._cursor = new veflux_1.Store(map_event_objects_1.CursorEvent);
        this._camera = new veflux_1.Store(map_event_objects_1.CameraEvent);
    }
    get cursor() { return this._cursor; }
    get map() { return this._map; }
    get camera() { return this._camera; }
    flyCameraTo(p) {
        this.camera.emmit('request_move', null, p);
    }
    cameraStartingMove() {
        if (this.camera.value)
            this.camera.emmit('start_move', this._camera);
    }
    setClickListener(component) {
        if (!this._clickStack.find(c => c == component))
            this._clickStack.push(component);
    }
    clearClickListener(component) {
        this._clickStack = this._clickStack.filter(c => c != component);
    }
    onMapClicked(position, feature, isRightClick) {
        // pass the click to the first item in the stack, working down if the first item returns false
        if (this._clickStack.length) {
            var lastEvent = false;
            for (var x = this._clickStack.length - 1; x >= 0 && !lastEvent; x--) {
                lastEvent = this._clickStack[x].onMapClicked(position, feature, isRightClick);
            }
            return lastEvent;
        }
        throw new Error("Method not implemented.");
    }
}
exports.MapEventService = MapEventService;
